import type { CheckoutMethod } from '../api/checkout-session-types'

const storagePrefix = 'checkout-restart-method:'
type MethodChoice = Pick<CheckoutMethod, 'provider' | 'pm_id' | 'purchase_option_id'>

// 只保留展示选择，付款能力、金额和可用方式仍由新会话响应决定。
export function rememberRestartMethodChoice(
  sessionNo: string,
  method: CheckoutMethod | null
): void {
  if (!method) return
  const choice: MethodChoice = {
    provider: method.provider,
    pm_id: method.pm_id,
    purchase_option_id: method.purchase_option_id,
  }
  sessionStorage.setItem(storagePrefix + sessionNo, JSON.stringify(choice))
}

export function copyRestartMethodChoice(sourceSessionNo: string, successorSessionNo: string): void {
  const choice = readChoice(sourceSessionNo)
  if (choice) sessionStorage.setItem(storagePrefix + successorSessionNo, JSON.stringify(choice))
}

export function restartMethodReference(
  sessionNo: string,
  available: CheckoutMethod[]
): string | null {
  const choice = readChoice(sessionNo)
  if (!choice) return null
  return (
    available.find(
      (method) =>
        method.provider === choice.provider &&
        method.pm_id === choice.pm_id &&
        method.purchase_option_id === choice.purchase_option_id
    )?.method_reference ?? null
  )
}

function readChoice(sessionNo: string): MethodChoice | null {
  const key = storagePrefix + sessionNo
  const value = sessionStorage.getItem(key)
  if (!value) return null
  let choice: unknown
  try {
    choice = JSON.parse(value)
  } catch {
    sessionStorage.removeItem(key)
    return null
  }
  if (
    typeof choice === 'object' &&
    choice !== null &&
    'provider' in choice &&
    typeof choice.provider === 'string' &&
    choice.provider.length > 0 &&
    'pm_id' in choice &&
    typeof choice.pm_id === 'string' &&
    choice.pm_id.length > 0 &&
    'purchase_option_id' in choice &&
    Number.isSafeInteger(choice.purchase_option_id) &&
    Number(choice.purchase_option_id) > 0
  ) {
    return {
      provider: choice.provider,
      pm_id: choice.pm_id,
      purchase_option_id: Number(choice.purchase_option_id),
    }
  }
  sessionStorage.removeItem(key)
  return null
}
